import { Box, useMediaQuery, useTheme } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	FieldLayout,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useState } from "react";
import { payrollEarningsRl1Codes, payrollEarningsT4Codes } from "../../AdminEarningsSetup/Panels/AdminEarningsInfoSetupFieldsPanel";

import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";

interface IDeductionsInfoSetupFieldsPanel {
	onDeductionsSelectionChangeHandler: (value: any) => void;
	deductionsDDLItems: any
	formMethods: any

}
export const DeductionsInfoSetupFieldsPanel: FC<
	IDeductionsInfoSetupFieldsPanel
> = ({ deductionsDDLItems, onDeductionsSelectionChangeHandler, formMethods }) => {
	const [deductionType, setDeductionType] = useState(null)

	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;


	const onDeductionsTypeSelectionChangeHandler = (value: any) => {
		let selected = value.value;
		if (selected) {
			formMethods.setValue('deductionFrom', 100)
			setDeductionType(selected)
		} else {
			setDeductionType(null)
		}
	}

	return (
		<Box
			sx={{
				padding: "0",
				"& .MuiTextField-root": { marginTop: 0, marginBottom: "12px" },
			}}>
			{mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
				label="Load Deductions"
				selectName="deduction"
				testId={`deduction`}
				labelPosition={LabelPosition.Top}
				items={deductionsDDLItems ?? []}
				onSelectionChangeHandler={onDeductionsSelectionChangeHandler}
				showEmpty
			/>}
			<RHookFormTextFieldWithLabel
				label="Label"
				id="label"
				testId={`label`}
				labelPosition={LabelPosition.Top}
			// labelColumns={4}
			// fieldColumns={8}
			// required
			/>
			<EnhancedDropDownRHFWithLabel
				label="Show in Payroll"
				selectName="showInPayroll"
				testId={`Show-in-Payroll`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
			// required
			// labelColumns={4}
			// fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Deduction Type"
				selectName="deductionType"
				testId={`deductionType`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "RPP", value: 300 },
					{ label: "Union Dues", value: 400 },
					{ label: "Deduction by Court Order", value: 200 },
					{ label: "Annual Deductions (Child Care etc.)", value: 100 },
				]}
				onSelectionChangeHandler={onDeductionsTypeSelectionChangeHandler}
				showEmpty
			// labelColumns={4}
			// fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Deducted From"
				selectName="deductionFrom"
				testId={`deducted-Form`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Net Pay", value: 200 },
					{ label: "Gross", value: 100 },
				]}
				selectedItem={200}
				isDisabled={deductionType ? true : false}
			// required
			// labelColumns={4}
			// fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Deduction Method"
				selectName="deductionMethod"
				testId={`deducted-Method`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Amount", value: 100 },
					{ label: "Percentage of Total Gross", value: 400 },
					{ label: "Percentage of Gross + Cash Earnings", value: 200 },
					{ label: "Percentage of Gross Only", value: 300 },
				]}
				selectedItem={100}
			// required
			// labelColumns={4}
			// fieldColumns={8}
			/>
			<FieldWrapper>
				<FieldLayout
					label="Max YTD"
					testId="Max-YTD"
					labelPosition={LabelPosition.Top}
				// labelColumns={4}
				// fieldColumns={8}
				>
					<RHookFormNumericFormatTextField
						id={"maxYtd"}
						testId={`maxYtd`}
						defaultValue={"0.00"}
						textAlign={"end"}
					/>
				</FieldLayout>
			</FieldWrapper>
			<EnhancedDropDownRHFWithLabel
				label="T4 Code"
				selectName="t4Code"
				testId={`T4-Code`}
				labelPosition={LabelPosition.Top}
				items={payrollEarningsT4Codes}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="RL-1 Code"
				selectName="rl1Code"
				testId={`rl1Code`}
				labelPosition={LabelPosition.Top}
				items={payrollEarningsRl1Codes}
				labelColumns={4}
				fieldColumns={8}
			/>
		</Box>
	);
};
